module.exports = __webpack_public_path__ + "img/imagem-03-detalhada-palmeiras-04.f4cd8b0d.png";